<template>
  <div class="copyright-box" :style="{ color: textColor }">
    <div class="copyright">版权所有：中国社会科学出版社　京ICP备05032912号-4 </div>
    <div class="police">
      <img src="https://www.sklib.cn/images/jgwab.png" alt="">
      <div class="canClick"
        @click="openUrl('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202010100')">
        京公网安备11010202010100号</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'copyright',
  props: {
    textColor: {
      type: String,
      default: '#f5f5f5' // 设置默认颜色
    }
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
.copyright-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  font-size: 14px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 10px;

  .police {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 15px;

    .canClick {
      margin-left: 5px;
      cursor: pointer;
      transition: all .3s ease;

      &:hover {
        color: #F07E9D;
      }
    }
  }


  @media screen and (max-width: 1200px) {
    display: block;
    text-align: center;
    margin-top: 50px;

    .police {
      margin-left: 0;
    }
  }
}
</style>